export default __webpack_public_path__ + "static/media/Metabell总部.d2515615.jpg";